import { Path } from '@/main/router/routerPath';

import KampaneList from './pages/KampaneList.vue';
import { Vozidlo } from './vozidlo';
import { Partner } from './partner';
import { ZakaznikProdejce } from './zakaznikProdejce';
import { ZakaznikKontakt } from './zakaznikKontakt';

export const router = new Path('kartoteka').addChildren([
	new Path('Kampane', { List: KampaneList }, 'CRM_Kampane'),

	Vozidlo.router,
	Partner.router,
	ZakaznikProdejce.router,
	ZakaznikKontakt.router,
]);
